import BaseRepository from "@/baseRepository/BaseRepository";
const labelResource = `/api/v1/pagelabels`;

export default{
  getPagesLabelWithFilter(baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.get(`${labelResource}/filter`, {
      baseURL,
      headers,
      params
    });
  },
}